import { cartQuery, userErrors } from '@app/helpers/graphql/shopify/queries';

export const removeCartLinesMutation = `
cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
    ${cartQuery}
    ${userErrors}
}
`;
